/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Thai (Thailand)
export default {
  'fabric.elements.mentions.team.member.50plus': 'ทีม • สมาชิกมากกว่า 50 คน',
  'fabric.elements.mentions.team.member.50plus.including.you': 'ทีม • สมาชิกมากกว่า 50 คน รวมคุณด้วย',
  'fabric.elements.mentions.team.member.count': '{0, plural, other {ทีม • สมาชิก {0} คน}}',
  'fabric.elements.mentions.team.member.count.including.you': '{0, plural, other {ทีม • สมาชิก {0} คน รวมคุณด้วย}}',
  'fabric.mention.error.defaultAction': 'ลองอีกครั้งในอีกสักครู่',
  'fabric.mention.error.defaultHeadline': 'มีข้อผิดพลาดบางอย่างเกิดขึ้น',
  'fabric.mention.error.differentText': 'ลองป้อนข้อความอื่น',
  'fabric.mention.error.loginAgain': 'ลองออกจากระบบและเข้าสู่ระบบใหม่อีกครั้ง',
  'fabric.mention.noAccess.label': 'ไม่มีการเข้าถึง',
  'fabric.mention.noAccess.warning': '{name} จะไม่ได้รับการแจ้งเตือนเนื่องจากพวกเขาไม่มีสิทธิ์การเข้าถึง',
  'fabric.mention.unknow.user.error': 'ผู้ใช้ที่ไม่รู้จัก {userId}'
};